import api from "./api";

// 项目删除
export const sidebarProjectDelete = async (projectId: string) => {
  const res = await api.post<unknown>("/sidebar/project/delete", { project_id: projectId });
  return res;
};
